import React from "react";
import {useSelector} from "react-redux";
import Styles from './styles.module.scss';
import Moment from "react-moment";
import DOMPurify from "dompurify";
import {useTranslation} from "react-i18next";




const MainNews = () => {
    const { t } = useTranslation();
    const news = useSelector(store => store.main.latestNews);

    const postLinkHandler = (id) => {
        window.location.assign(`${process.env.REACT_APP_NEXT_URL}/news/${id}`);
    };

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Новости')}</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.newsBox}`}>
                        {news?.length > 0 ?
                            news.map((item, index)=>{
                                if (index < 3){
                                    return (
                                        <div className={`${Styles.newsBoxItem}`} key={'mainNews' + index} onClick={()=>{postLinkHandler(item.id)}}>
                                            <div className={`${Styles.newsBoxItemImgWrap}`}>
                                                <img src={item.picture} alt={item.title}/>
                                            </div>
                                            <div className={`${Styles.dateWrap}`}>
                                                <div className={`${Styles.date}`}><Moment format="DD/MM/YYYY">{item.created_at}</Moment></div>
                                            </div>
                                            <div className={`${Styles.title2}`}>{item.title}</div>
                                            <div
                                                className={`${Styles.newsBoxItemDescription}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(item.content),
                                                }}
                                            />
                                            <div className={`${Styles.newsBoxItemCategory}`}>{item.category?.name}</div>
                                        </div>
                                    )
                                } else return null
                            }) : null}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MainNews;